import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import AuthShell from "./AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
      toast.success("If that email is registered, a reset link is on its way.");
    } catch {
      // Endpoint is designed to always return 200. Any error is a network issue.
      toast.error("Couldn't reach the server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Forgot your password?"
      subtitle="Enter the email on your account and Dox will send you a reset link."
      footer={<><Link to="/login" data-testid="link-back-login" className="text-dox-orange font-semibold hover:underline">Back to login</Link></>}
    >
      {sent ? (
        <div data-testid="reset-sent" className="rounded-xl bg-emerald-500/10 border border-emerald-400/30 px-5 py-4 text-emerald-200 text-sm">
          If <span className="font-semibold">{email}</span> is registered, we&apos;ve sent a password reset link. It expires in 60 minutes.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <label className="block">
            <span className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-1.5 block">Email</span>
            <input
              data-testid="forgot-email"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-dox-orange focus:ring-2 focus:ring-dox-orange/20 transition"
            />
          </label>
          <button
            data-testid="forgot-submit"
            disabled={loading}
            className="w-full rounded-full bg-dox-orange py-3.5 font-bold text-white hover:bg-dox-orangeHover disabled:opacity-60 transition-all min-h-[52px]"
          >
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
